

























































import { Component, Vue } from 'vue-property-decorator';
import HeadLable from '@/components/HeadLable/index.vue';
import { addCompetition, queryCompetitionById, updateCompetition } from '@/api/competition.ts';

@Component({
  name: 'addCompetition',
  components: {
    HeadLable
  }
})
export default class extends Vue {
  private title = '新建赛事';
  private actionType = 'add';
  private ruleForm = {
    id: '', // 添加 id 字段，用于编辑时标识赛事
    content: '',
    valueTime: [],
    votes: '',
    hots: ''
  };

  private rules = {
    content: [
      {
        required: true,
        message: '请输入赛事标题',
        trigger: 'blur'
      }
    ],
    valueTime: [
      {
        required: true,
        message: '请选择赛事时间',
        trigger: 'blur'
      }
    ],
    votes: [
      {
        required: true,
        message: '请输入免费投票次数',
        trigger: 'blur'
      }
    ],
    hots: [
      {
        required: true,
        message: '请输入每次增加热度',
        trigger: 'blur'
      }
    ],
  };

  created() {
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    if (this.$route.query.id) {
      this.title = '修改赛事信息';
      this.init();
    }
  }

  private async init() {
    const params = {
      id: this.$route.query.id,
      type: 0
    };
    queryCompetitionById(params).then((res: any) => {
      if (res.data.code === 1) {
        this.ruleForm = {
          ...this.ruleForm,
          id: res.data.data.id, // 确保 id 被正确赋值
          content: res.data.data.content,
          valueTime: [res.data.data.startTime, res.data.data.endTime],
          votes: res.data.data.votes,
          hots: res.data.data.hots
        };
      } else {
        this.$message.error(res.data.msg);
      }
    });
  }

  private submitForm(continueAdd: boolean = false) {
    (this.$refs.ruleForm as any).validate((valid: boolean) => {
      if (valid) {
        const params = {
          id: this.ruleForm.id, // 添加 id 字段
          content: this.ruleForm.content,
          startTime: this.ruleForm.valueTime[0],
          endTime: this.ruleForm.valueTime[1],
          votes: this.ruleForm.votes,
          hots: this.ruleForm.hots,
          type: 0
        };

        if (this.actionType === 'add') {
          addCompetition(params)
            .then((res: any) => {
              if (res.data.code === 1) {
                this.$message.success('赛事新建成功！');
                if (!continueAdd) {
                  this.$router.push({ path: '/competition/titleManage' });
                } else {
                  this.ruleForm = {
                    content: '',
                    valueTime: []
                  };
                }
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(() => {
              this.$message.error('请求出错了');
            });
        } else if (this.actionType === 'edit') {
          updateCompetition(params)
            .then((res: any) => {
              if (res.data.code === 1) {
                this.$message.success('赛事修改成功！');
                this.$router.push({ path: '/competition/titleManage' });
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(() => {
              this.$message.error('请求出错了');
            });
        }
      } else {
        this.$message.error('表单验证失败，请检查输入');
      }
    });
  }
}
